declare global {
  interface Window {
    gtag: any;
    AuthenticationContext: MicrosostAuthenticationContext;
    gapi: any;
  }
}

type InitParams = {
  instance: string;
  tenant: 'common'; //COMMON OR YOUR TENANT ID
  clientId: string;
  redirectUri: string;
  popUp: boolean;
  callback: (err: any, token: string) => void;
};

interface IADAL {
  login: () => void;
  getCachedUser: () => { profile: { unique_name: string } };
}
export abstract class MicrosostAuthenticationContext implements IADAL {
  instance: string;
  tenant: string;
  clientId: string;
  redirectUri: string;
  popUp: boolean;
  callback: (err: any, token: string) => void;
  constructor({
    instance,
    tenant,
    clientId,
    redirectUri,
    popUp,
    callback,
  }: InitParams) {
    this.instance = instance;
    this.tenant = tenant;
    this.clientId = clientId;
    this.redirectUri = redirectUri;
    this.popUp = popUp;
    this.callback = callback;
  }
  login() {}
  getCachedUser() {
    return { profile: { unique_name: 'none' } };
  }
}

export const events = {
  USER_LOGGED_OUT: 'User logged out',
  USER_LOGGED_IN: 'User logged in',
  USER_SIGNED_UP: 'User signed up',
};

export const identify = (user_id: string) => {
  if (typeof window !== 'undefined') {
    window.gtag('set', { user_id });
  }
};
// log specific events happening.
export const track = ({ action, params }: any) => {
  if (typeof window !== 'undefined') {
    window.gtag('event', action, params);
  }
};
